
import { Drawer } from "melco-ui";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { ExtendTrialForm } from "../form/ExtendTrialForm";
import { ExtendTrialActionButtonInterface } from "../ExtendTrialActionButton";
import { useTranslation } from "react-i18next";



type ExtendTrialDrawerProps = {
  isDrawerOpen: boolean;
  onCloseDrawer: (isDrawerOpen: boolean) => void;
  ExtendTrialActionDetailValues: ExtendTrialActionButtonInterface
};

export const ExtendTrialDrawer: React.FC<ExtendTrialDrawerProps> = ({
  isDrawerOpen,
  onCloseDrawer,
  ExtendTrialActionDetailValues
}) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer()

  return (

    <Drawer
      title={t('users.tabs.trials.drawer_title')}
      placement="right"
      width={750}
      closable={true}
      onClose={() => onCloseDrawer(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: '32px' }}
    >
      {isDrawerOpen && <ExtendTrialForm
        ExtendTrialActionDetails={
          ExtendTrialActionDetailValues
        }
        referenceDrawer={referenceDrawer}
        onCloseDrawer={onCloseDrawer} />}
    </Drawer>
  );
};
